import moment from "moment";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import MyToolTip from "../../ReuseComponenets/MyToolTip";

const SendTopicsStartsClass = ({
  getPLannerDetails,
  plannerData,
  submitPlannerHistory,
  plannerDataForHistory,
  classTime,
}) => {
  console.log(
    "plannerDataForHistory",
    plannerDataForHistory && JSON.parse(plannerDataForHistory.feed_data)
  );
  const [histoyPlannerSent, sethistoyPlannerSent] = useState([]);
  const [btnLoading, setbtnLoading] = useState(false);

  const selectedTopic = (e, topicDetails) => {
    if (e.target.checked) {
      var makeArray = {
        topicId: topicDetails.topicId,
        topicName: topicDetails.topicName,
        chapterId: topicDetails.chapterId,
        chapterName: topicDetails.chapterName,
        worksheet: [],
        videos: [],
      };
      sethistoyPlannerSent([...histoyPlannerSent, makeArray]);
      debugger;
    } else {
      var deleteTopic = histoyPlannerSent.filter((item) => item.topicId !== topicDetails.topicId);
      sethistoyPlannerSent([...deleteTopic]);
      debugger;
    }
  };

  const addWorksheet = (e, worksheetDetails) => {
    if (histoyPlannerSent.length) {
      if (e.target.checked) {
        var getWorksheet = histoyPlannerSent.filter(
          (item) => item.topicId == worksheetDetails.topic_id
        );

        getWorksheet[0]["worksheet"].push({ ...worksheetDetails });
        sethistoyPlannerSent([...histoyPlannerSent]);
      } else {
        var getTopic = histoyPlannerSent.filter(
          (item) => item.topicId == worksheetDetails.topic_id
        );
        var getWorksheet = getTopic[0]["worksheet"].filter(
          (worksheetId) => worksheetId.id !== worksheetDetails.id
        );

        getTopic[0]["worksheet"] = getWorksheet;

        sethistoyPlannerSent([...histoyPlannerSent]);
        debugger;
      }
    } else {
      alert("Select Topic first");
    }
  };

  const addVideo = (e, worksheetDetails) => {
    if (histoyPlannerSent.length) {
      if (e.target.checked) {
        var getWorksheet = histoyPlannerSent.filter(
          (item) => item.topicId == worksheetDetails.test_id
        );

        getWorksheet[0]["videos"].push({ ...worksheetDetails });
        sethistoyPlannerSent([...histoyPlannerSent]);
      } else {
        var getTopic = histoyPlannerSent.filter((item) => item.topicId == worksheetDetails.test_id);
        var getWorksheet = getTopic[0]["videos"].filter(
          (worksheetId) => worksheetId.video_id !== worksheetDetails.video_id
        );

        getTopic[0]["videos"] = getWorksheet;

        sethistoyPlannerSent([...histoyPlannerSent]);
        debugger;
      }
    } else {
      alert("Select Topic first");
    }
  };

  const mergeandSend = () => {
    debugger;
    setbtnLoading(true);
    let initial = plannerDataForHistory && JSON.parse(plannerDataForHistory.feed_data);
    if (initial.planner_topic) {
      let planner_topic = [...initial.planner_topic, ...histoyPlannerSent];
      initial = { ...initial, planner_topic };
      submitPlannerHistory(planner_topic);
      console.log("Final Data", initial);
    } else {
      submitPlannerHistory(histoyPlannerSent);
    }
  };
  console.log("Send Topic Class History", histoyPlannerSent);
  return (
    <div id="accordionForTeacherManagementNew">
      <h5>Send Topics, Videos and Worksheets for {classTime}:</h5>
      <div className="table-responsive">
        <table className="table table-lg">
          <tr className="font-weight-bold d-flex">
            <th className="col-md-1" scope="row"></th>
            <td className="col-md-5">
              Topics from
              <select
                onChange={(e) => getPLannerDetails(e.target.value)}
                style={{ border: "none" }}
              >
                <option value={moment().subtract(0, "month").startOf("month").format("MMMM")}>
                  {moment().subtract(0, "month").startOf("month").format("MMMM")}
                </option>
                <option value={moment().subtract(1, "month").startOf("month").format("MMMM")}>
                  {moment().subtract(1, "month").startOf("month").format("MMMM")}
                </option>
                <option value={moment().subtract(2, "month").startOf("month").format("MMMM")}>
                  {moment().subtract(2, "month").startOf("month").format("MMMM")}
                </option>
                <option value={moment().subtract(3, "month").startOf("month").format("MMMM")}>
                  {moment().subtract(3, "month").startOf("month").format("MMMM")}
                </option>
              </select>{" "}
              planner
            </td>
            <td className="col-sm-2">
              <i className="fas fa-question-circle" id="TooltipExampleQuestion"></i>

              <MyToolTip placement="right" text="Questions" target={"TooltipExampleQuestion"} />
            </td>
            <td className="col-sm-2">
              <i className="fas fa-video" id="TooltipExampleVideo"></i>
              <MyToolTip placement="right" text="Videos" target={"TooltipExampleVideo"} />
            </td>
            <td className="col-sm-2">
              <i className="fas fa-file-word" id="TooltipExampleWorksheet"></i>
              <MyToolTip placement="right" text="Worksheets" target={"TooltipExampleWorksheet"} />
            </td>
          </tr>
          <tbody>
            {plannerData.length > 0 ? (
              plannerData.map((item, index) => (
                <>
                  <tr
                    className="collapsed d-flex onTableHover"
                    data-toggle="collapse"
                    data-target={`#OneTwo${index}`}
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    <td className="col-sm-1">
                      {" "}
                      <input
                        className="showOnHover"
                        type="checkbox"
                        onClick={(e) => selectedTopic(e, item)}
                      />
                      {item.history_timestamps &&
                        JSON.parse(item.history_timestamps).length > 0 && (
                          <span
                            className="text-italic ml-1"
                            style={{
                              position: "relative",
                              top: -2,
                              fontSize: 12,
                              color: "#D4FCB5",
                            }}
                          >
                            <i className="fa fa-check" id={`TooltipExample${index}`}></i>
                            {item.history_timestamps && JSON.parse(item.history_timestamps) ? (
                              <MyToolTip
                                text={
                                  JSON.parse(item.history_timestamps) &&
                                  JSON.parse(item.history_timestamps).map((item) => (
                                    <label>
                                      {moment(item).format("ll")}
                                      &nbsp;,&nbsp;
                                    </label>
                                  ))
                                }
                                // text="2 Aug , 3 Aug"
                                target={`TooltipExample${index}`}
                              />
                            ) : null}
                          </span>
                        )}
                    </td>
                    <td className="col-sm-5">
                      {" "}
                      <label className="animated fadeInDown mb-0">{item.topicName}</label>
                      <p className="text-italic" style={{ fontSize: 12, color: "#c1c1c1" }}>
                        (Chapter: {item.chapterName})
                      </p>
                    </td>
                    <td className="col-sm-2">{item.questions_count}</td>
                    <td className="col-sm-2">
                      {item.videos_count}{" "}
                      {/* <span className="ml-1">
                      {" "}
                      <i
                        className={
                          item.videos_count > 0
                            ? "fa fa-plus-circle uploadIcon"
                            : "fa fa-plus-circle text-danger uploadIcon"
                        }
                        onClick={() => openVideoModalDetails(item)}
                        id={`showAddVideoToolTip${index}`}
                      ></i>
                      <MyToolTip
                        placement="right"
                        text="Add Videos"
                        target={`showAddVideoToolTip${index}`}
                      />
                    </span> */}
                    </td>
                    <td className="col-sm-2">
                      {item.Worksheets_count}{" "}
                      {/* <span className="ml-1">
                      {" "}
                      <i
                        className={
                          item.Worksheets_count > 0
                            ? "fa fa-plus-circle uploadIcon"
                            : "fa fa-plus-circle text-danger uploadIcon"
                        }
                        onClick={() => openWorksheetModalDetails(item)}
                        id={`showAddWorksheetToolTip${index}`}
                      ></i>
                      <MyToolTip
                        placement="right"
                        text="Add Worksheets"
                        target={`showAddWorksheetToolTip${index}`}
                      />
                    </span> */}
                      <i
                        className="fa fa-chevron-down ml-1"
                        style={{
                          float: "right",
                          color: "lightgray",
                        }}
                      ></i>
                    </td>
                  </tr>
                  <div
                    id={`OneTwo${index}`}
                    className="collapse accordionBox"
                    aria-labelledby="headingOne"
                    data-parent="#accordionForTeacherManagementNew"
                  >
                    <tr className="d-flex">
                      <td className="col-sm-1"></td>
                      <td className="col-sm-8">
                        <div className="">
                          {/* <hr /> */}
                          <label className="font-weight-bold">
                            <i className="fas fa-file-word mr-2"></i> Share Worksheets:
                          </label>

                          {item.Worksheets &&
                            item.Worksheets.map((worksheet, index2) => (
                              <div key={index2} className="d-flex justify-content-between mb-2">
                                <div>
                                  <input
                                    type="checkbox"
                                    className="mr-2"
                                    onClick={(e) => addWorksheet(e, worksheet)}
                                  />
                                  {worksheet.label}
                                  &nbsp;
                                  {worksheet.added_by_teacher == 1 && (
                                    <span
                                      style={{
                                        fontSize: 12,
                                        color: "#c1c1c1",
                                      }}
                                    >
                                      (by {worksheet.user_name})
                                    </span>
                                  )}
                                </div>
                                <div>
                                  {/* <i
                                  style={{
                                    cursor: "pointer",
                                  }}
                                  onClick={() => updateLabel(worksheet, item)}
                                  className="fa-solid fa-pencil ml-5"
                                ></i> */}
                                  <button
                                    className="play-button"
                                    onClick={() => window.open(worksheet.link, "_blank")}
                                  >
                                    Preview
                                  </button>
                                </div>
                              </div>
                            ))}

                          {/* <div>
                          <button
                            className="btn btn-light btn-sm"
                            onClick={() => openWorksheetModalDetails(item)}
                          >
                            Add more worksheets <i className="fa fa-plus-circle"></i>
                          </button>
                        </div> */}
                        </div>
                        <div className="mt-4">
                          <label className="font-weight-bold">
                            <i className="fas fa-video mr-2"></i>
                            Share Videos:
                          </label>

                          {item.videos &&
                            item.videos.map((videos, index3) => (
                              <div key={index3} className="d-flex justify-content-between mb-2">
                                <div>
                                  <input
                                    type="checkbox"
                                    className="mr-2"
                                    onClick={(e) => addVideo(e, videos)}
                                  />
                                  {videos.video_caption} &nbsp;
                                  {videos.added_by_teacher == 1 && (
                                    <span
                                      style={{
                                        fontSize: 12,
                                        color: "#c1c1c1",
                                      }}
                                    >
                                      (by {videos.user_name})
                                    </span>
                                  )}
                                </div>
                                <div>
                                  {/* <i
                                  style={{
                                    cursor: "pointer",
                                  }}
                                  onClick={() => updateVideoLabel(videos, item)}
                                  className="fa-solid fa-pencil ml-5"
                                ></i> */}
                                  <button
                                    className="play-button"
                                    onClick={() => window.open(videos.video_url, "_blank")}
                                  >
                                    Preview
                                  </button>
                                </div>
                              </div>
                            ))}
                          {/* <div>
                          <button
                            className="btn btn-light btn-sm"
                            onClick={() => openVideoModalDetails(item)}
                          >
                            Add more videos <i className="fa fa-plus-circle"></i>
                          </button>
                        </div> */}
                        </div>
                      </td>
                      <td className="col-sm-1"></td>
                      <td className="col-sm-2"></td>
                    </tr>
                  </div>
                </>
              ))
            ) : (
              <Link to="/TeacherDashboard/Planner">
                <tr className="collapsed d-flex">
                  <td className="col-sm-12 text-center mt-5">
                    <label className="text-danger">No Planner Found for this month &nbsp;</label>
                    <label className="" style={{ color: "#c1c1c1" }}>
                      <i className="fa fa-plus-circle text-danger"></i>{" "}
                      <label
                        style={{ cursor: "pointer" }}
                        className="text-danger font-weight-bold cursor-pointer"
                      >
                        Create
                      </label>{" "}
                      <span className="text-danger">Planner</span>{" "}
                    </label>
                  </td>
                </tr>
              </Link>
            )}
          </tbody>
        </table>
        <div className="text-right">
          {btnLoading && (
            <label className="text-muted text-sm">Working on it, don't go away...</label>
          )}
          <br />
          <button
            disabled={btnLoading}
            className="btn btn-sm btn-success"
            onClick={() => mergeandSend()}
          >
            Send Details{" "}
            {btnLoading && (
              <div class="spinner-border spinner-border-sm" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SendTopicsStartsClass;
